var map = {
	"./android/Device": 1006,
	"./androidtv/Device": 1218,
	"./arris/Device": 1223,
	"./hisense/Device": 1234,
	"./lg/Device": 1242,
	"./nagra/Device": 1251,
	"./netrange/Device": 1262,
	"./opera/Device": 1270,
	"./polaroid/Device": 1278,
	"./ps4/Device": 1286,
	"./samsung/Device": 1294,
	"./seirobotics/Device": 1302,
	"./sony/Device": 1307,
	"./stbcoship/Device": 1315,
	"./stbcoship9108/Device": 1319,
	"./stbhuawei/Device": 1323,
	"./stbkaon/Device": 1327,
	"./tizen/Device": 1330,
	"./web0s/Device": 1339,
	"./workstation/Device": 639,
	"./workstationChafari/Device": 1353,
	"./zeasn/Device": 1361,
	"./zte/Device": 1369
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1005;


//////////////////
// WEBPACK FOOTER
// ./src/devices ^\.\/.*\/Device$
// module id = 1005
// module chunks = 0